export enum ActionTypeEnum {
    ADD = "Added",
    EDIT = "Updated",
    PLACED = "Placed",
    DELETE = "Deleted",
    CHANGE = "Changed",
    CREATE = "Created",
    APPROVE = "Approved",
    CANCEL = "Canceled",
}